import searchViewType from './searchViewType';

export default {
  searchView: searchViewType.TABLE_VIEW,
  pageSize: 50,
  metadataEditor: false,
  cosmosTheme: 'light',
};
